<template>
	<div class=" m-t-0 w-1200" style="color:#333">
    <span style="font-weight:600;color:#00f;" class="m-l-30">【配置名称】配置内容 描述：配置描述</span>
		<el-form ref="form" :model="form" :rules="rules" label-width="300px" class="m-t-10 padding-page">
      <div class="form-pane">
      <el-form-item v-for="(item,index) in form.list" :label="' 【'+item.name+'】'" prop="list">
        <el-input v-if="item.config_type==1 || item.config_type==4" v-model.trim="item.value" :value="item.value" class="m-l-10 h-40 w-600"></el-input>
        <el-radio-group v-if="item.config_type==2" v-model.trim="item.value" class="m-l-10 h-40 w-600">
          <el-radio label="1">开启</el-radio>
          <el-radio label="0">关闭</el-radio>
        </el-radio-group>
        <div class="m-l-10 fl w-600" v-if="item.config_type==3">
          <img style="width:285px;height: 160px;cursor:pointer;background-color:#aaa;" :src="item.value" class="fl m-r-10" v-on:click="handlePictureCardPreview(item.value)">
          <el-upload
            :action="uploadUrl"
            type="drag"
            :thumbnail-mode="true"
            :on-preview="viewPic"
            :on-remove="handleRemove"
            :on-success="(response, file, fileList)=>{return uploadSuccess(response, file, fileList,item)}"
            :on-error="uploadFail"
            :show-file-list="false">
            <i class="el-icon-upload"></i>
            <div class="el-dragger__text" v-on:click="set_upload(index)">将文件拖到此处，或<em>点击上传</em>  jpg/png文件</div>
          </el-upload>
        </div>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;描述：<el-input v-model.trim="item.remark" :value="item.remark" class="m-l-10 h-40 w-400"></el-input>
      </el-form-item>
      </div>
      <el-form-item>
        <el-button type="primary" @click="add()" class="m-l-10 w-200" :loading="isLoading" size="small">保存</el-button>
      </el-form-item>
    </el-form>


    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" style="background-color:#aaa;" alt="">
    </el-dialog>


    <el-dialog title="添加配置" :visible.sync="dialogFormVisible" size="tiny">
      <el-form ref="form" :model="formconfig" label-width="30%" :rules="rules">
        <el-form-item label="配置名称" prop="name" :label-width="formLabelWidth">
          <el-input v-model.trim="formconfig.name" placeholder="例如：SET_NAME" style="width:80%;"></el-input>
        </el-form-item>
        <el-form-item label="配置描述" prop="remark" :label-width="formLabelWidth">
          <el-input v-model.trim="formconfig.remark" placeholder="例如：前端展示——平台名称" style="width:80%;"></el-input>
        </el-form-item>
        <el-form-item label="配置内容" prop="value" :label-width="formLabelWidth">
          <el-input v-model.trim="formconfig.value" placeholder="例如：小程序，单选按钮填0或1" style="width:80%;"></el-input>
        </el-form-item>
        <el-form-item label="配置类型" prop="type">
          <el-select  v-model="formconfig.type" placeholder="选择配置的展示类型" style="width:80%">
            <el-option label="输入框" :value="1"></el-option>
            <el-option label="单选按钮" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="save('form')" size="small">确 定</el-button>
      </div>
    </el-dialog>
	</div>
</template>
<script>
  import http from '../../../../assets/js/http'

  export default {
    data() {
      return {
        isLoading: false,
        dialogFormVisible: false,
        picFormVisible: false,
        dialogImageUrl: '',
        dialogVisible: false,
        fileList: [],
        pic: '',
        form: {
          list: []
        },
        formconfig: {
          name: '',
          remark: '',
          value: '',
          type: ''
        },
        file_index: '',
        rules: {
          SET_WECHAT_NAME: [
            { required: true, message: '请输入微信公众号名称' }
          ]
        }
      }
    },
    methods: {
      //  保存配置
      add() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            this.apiPost('admin/website/save', this.form).then((res) => {
              this.handelResponse(res, (data) => {
                _g.toastMsg('success', '保存成功')
                this.isLoading = !this.isLoading
                this.getAllUsers()
              }, () => {
                this.isLoading = !this.isLoading
              })
            })
          }
        })
      },
      handlePictureCardPreview(url) {
        this.dialogImageUrl = url
        this.dialogVisible = true
      },
      getAllUsers() {
        this.loading = true
        this.apiPost('admin/website/index').then((res) => {
          this.handelResponse(res, (data) => {
            this.form.list = data
          })
        })
      },
      uploadSuccess(res, file, fileList, item) {
        item.value = res.data
      }
    },
    created() {
      this.getAllUsers()
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// add.vue?f179be78